import React, { useEffect, useState } from 'react';
import { StyleProp, Text, TextStyle, View } from 'react-native';
import { expandableDescriptionStyles as styles } from './ExpandableDescription.styles';

const DEFAULT_PREVIEW_LENGTH = 140;

export type ExpandableDescriptionData = {
  description?: string | null;
  previewLength?: number;
  textStyle?: StyleProp<TextStyle>;
  moreTextStyle?: StyleProp<TextStyle>;
};

type Props = {
  data: ExpandableDescriptionData;
};

export function ExpandableDescription({ data }: Props) {
  const description = data?.description ?? '';
  const previewLength = data?.previewLength ?? DEFAULT_PREVIEW_LENGTH;
  const textStyleOverride = data?.textStyle;
  const moreTextStyleOverride = data?.moreTextStyle;
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setExpanded(false);
  }, [description]);

  if (!description) {
    return null;
  }

  const isTruncatable = description.length > previewLength;
  const isCollapsed = isTruncatable && !expanded;
  const visibleText = isCollapsed ? description.slice(0, previewLength) : description;

  return (
    <View style={styles.wrapper}>
      <Text style={[styles.text, !isCollapsed && styles.preLine, textStyleOverride]}>
        {visibleText}
        {isCollapsed ? ' ' : null}
        {isCollapsed ? (
          <Text
            accessibilityRole="button"
            onPress={() => setExpanded(true)}
            style={[styles.moreText, moreTextStyleOverride]}
          >
            [...]
          </Text>
        ) : null}
      </Text>
    </View>
  );
}
